import React, { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import PureEditor from "../pureEditor";
import { defaultTestCase } from "../../utils";
import { JSHINT as jshint } from "jshint";
import ErrorMessage from "./../../components/errorMessage";

window.JSHINT = jshint;

const TestFormModal = ({
  isOpen,
  submitForm,
  handleClose,
  defaultTestCase,
}) => {
  const [value, setValue] = useState(defaultTestCase.defaultTestCase);
  const [editorErrors, setEditorErrors] = useState([]);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  useEffect(() => {
    setValue(defaultTestCase.defaultTestCase);
  }, [defaultTestCase]);

  const onChange = (editor, data, value) => {
    setValue(value);
    setEditorErrors(checkErrors(value));
  };

  const checkErrors = (value) => {
    jshint(value.split("\n"), { esversion: 6 });

    const errors = jshint.data().errors ?? [];
    if (errors.length) {
      setIsSaveDisabled(true);
    } else {
      setIsSaveDisabled(false);
    }

    return errors;
  };

  const {
    formState: { errors },
    handleSubmit,
    register,
    reset,
    watch,
  } = useForm({
    mode: "onChange",
  });
  const onSubmit = handleSubmit((data) => {
    submitForm({ ...data, code: value });
    reset();
  });
  const watchTitle = watch("title");
  return (
    <Modal show={isOpen}>
      <Form onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title>Add new test case</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Title/description</Form.Label>
            <Form.Control
              placeholder="It should be equal to something"
              {...register("title", {
                validate: (value) => {
                  return true;
                },
                required: "Title/description is required",
              })}
            />
            {errors.title && errors.title.message && (
              <p>{errors.title.message}</p>
            )}
            <Form.Text className="text-muted">
              A test case title to describe what the case tries to test.
            </Form.Text>
          </Form.Group>
          <Form.Group>
            <Form.Label>Test code</Form.Label>
            {Boolean(watchTitle) && (
              <PureEditor
                value={value}
                options={{
                  readOnly: false,
                  mode: "javascript",
                  lineNumbers: true,
                  lint: { esversion: 6 },
                  gutters: ["CodeMirror-lint-markers"],
                  theme: "material",
                }}
                onChange={onChange}
              />
            )}
            {/* <ErrorMessage errors={editorErrors} /> */}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={isSaveDisabled || errors.title}
          >
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default TestFormModal;
